import React from 'react';
import { Facebook, Twitter, Instagram, Mail, MessageCircle, Phone } from 'lucide-react';
export function Footer() {
  return <footer id="footer" className="bg-black border-t border-gold-500/30 pt-16 pb-8" data-id="element-135">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-136">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-137">
          {/* Brand */}
          <div data-id="element-138">
            <a href="#" className="flex flex-col mb-6" data-id="element-139">
              <span className="text-2xl font-serif font-bold text-white tracking-wide" data-id="element-140">
                IsYou <span className="text-gold-500" data-id="element-141">.</span>
              </span>
              <span className="text-[10px] text-gray-400 tracking-[0.2em] uppercase" data-id="element-142">
                新加坡是您网
              </span>
            </a>
            <p className="text-gray-500 text-sm leading-relaxed mb-6" data-id="element-143">
              新加坡首选的高端伴游服务平台，致力于为精英人士提供尊贵、私密、安全的伴游体验。
            </p>
            <div className="flex space-x-4" data-id="element-144">
              <a href="#" className="text-gray-400 hover:text-gold-500 transition-colors" data-id="element-145">
                <Facebook className="w-5 h-5" data-id="element-146" />
              </a>
              <a href="#" className="text-gray-400 hover:text-gold-500 transition-colors" data-id="element-147">
                <Twitter className="w-5 h-5" data-id="element-148" />
              </a>
              <a href="#" className="text-gray-400 hover:text-gold-500 transition-colors" data-id="element-149">
                <Instagram className="w-5 h-5" data-id="element-150" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div data-id="element-151">
            <h4 className="text-white font-bold mb-6" data-id="element-152">快速链接</h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-153">
              <li data-id="element-154">
                <a href="#" className="hover:text-gold-500 transition-colors" data-id="element-155">
                  首页
                </a>
              </li>
              <li data-id="element-156">
                <a href="#" className="hover:text-gold-500 transition-colors" data-id="element-157">
                  伴游女郎
                </a>
              </li>
              <li data-id="element-158">
                <a href="#" className="hover:text-gold-500 transition-colors" data-id="element-159">
                  服务流程
                </a>
              </li>
              <li data-id="element-160">
                <a href="#" className="hover:text-gold-500 transition-colors" data-id="element-161">
                  关于我们
                </a>
              </li>
              <li data-id="element-162">
                <a href="#" className="hover:text-gold-500 transition-colors" data-id="element-163">
                  加入我们
                </a>
              </li>
            </ul>
          </div>

          {/* Help */}
          <div data-id="element-164">
            <h4 className="text-white font-bold mb-6" data-id="element-165">帮助中心</h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-166">
              <li data-id="element-167">
                <a href="#" className="hover:text-gold-500 transition-colors" data-id="element-168">
                  常见问题
                </a>
              </li>
              <li data-id="element-169">
                <a href="#" className="hover:text-gold-500 transition-colors" data-id="element-170">
                  隐私政策
                </a>
              </li>
              <li data-id="element-171">
                <a href="#" className="hover:text-gold-500 transition-colors" data-id="element-172">
                  服务条款
                </a>
              </li>
              <li data-id="element-173">
                <a href="#" className="hover:text-gold-500 transition-colors" data-id="element-174">
                  安全指南
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-175">
            <h4 className="text-white font-bold mb-6" data-id="element-176">联系我们</h4>
            <ul className="space-y-4 text-sm text-gray-400" data-id="element-177">
              <li className="flex items-center" data-id="element-178">
                <MessageCircle className="w-4 h-4 text-gold-500 mr-3" data-id="element-179" />
                <span data-id="element-180">WhatsApp: +65 8888 8888</span>
              </li>
              <li className="flex items-center" data-id="element-181">
                <Phone className="w-4 h-4 text-gold-500 mr-3" data-id="element-182" />
                <span data-id="element-183">Telegram: @IsYouSG</span>
              </li>
              <li className="flex items-center" data-id="element-184">
                <Mail className="w-4 h-4 text-gold-500 mr-3" data-id="element-185" />
                <span data-id="element-186">contact@isyou.sg</span>
              </li>
            </ul>
          </div>
        </div>

        {/* 友站链接 */}
        <div className="border-t border-white/10 pt-8 pb-8 mb-8" data-id="element-187">
          <h4 className="text-white font-bold text-sm mb-4" data-id="element-188">友站链接</h4>
          <div className="flex flex-wrap gap-3" data-id="element-189">
            {[{
            name: 'sglonelyguy.me',
            url: 'https://sglonelyguy.me/'
          }, {
            name: 'ttvip.life',
            url: 'https://ttvip.life/'
          }, {
            name: 'locanto.space',
            url: 'https://locanto.space/'
          }, {
            name: 'kkbaby.site',
            url: 'https://kkbaby.site/'
          }, {
            name: 'xfy8.com',
            url: 'https://xfy8.com/'
          }, {
            name: 'sgbeautycastle.live',
            url: 'https://sgbeautycastle.live/'
          }, {
            name: 'shiok26.site',
            url: 'https://shiok26.site/'
          }, {
            name: 'sgharem.site',
            url: 'https://sgharem.site/'
          }, {
            name: 'shiok8.xyz',
            url: 'https://shiok8.xyz/'
          }, {
            name: 'geylang777.info',
            url: 'https://geylang777.info/'
          }, {
            name: 'ttvip-62.site',
            url: 'https://ttvip-62.site/'
          }, {
            name: 'geylang666.me',
            url: 'https://geylang666.me/'
          }, {
            name: 'isyou.net',
            url: 'https://isyou.net/'
          }].map(link => <a key={link.name} href={link.url} target="_blank" rel="noopener noreferrer" className="px-3 py-1.5 bg-dark-800 border border-white/10 rounded text-xs text-gray-400 hover:text-gold-500 hover:border-gold-500/30 transition-colors" data-id="element-190">
                {link.name}
              </a>)}
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-gray-600" data-id="element-191">
          <p data-id="element-192">&copy; 2026 IsYou. All rights reserved.</p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-193">
            <a href="#" className="hover:text-gray-400" data-id="element-194">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-gray-400" data-id="element-195">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}